import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Send, Mail } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { trackClick } from "@/lib/api";

export default function Footer() {
  const s = useSettings();
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 bg-[#0A0A0A] text-zinc-400"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={s.logo_url} alt="VINKO" className="h-14 w-auto mb-4" />
          <p className="text-sm leading-relaxed">
            Vinko è un assistente virtuale che presenta promozioni, servizi e link
            ufficiali dei bookmaker partner.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-widest">
            Naviga
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-yellow-400">Home</Link></li>
            <li><Link to="/promozioni" className="hover:text-yellow-400">Promozioni</Link></li>
            <li><Link to="/bookmaker" className="hover:text-yellow-400">Bookmaker</Link></li>
            <li><Link to="/come-funziona" className="hover:text-yellow-400">Come funziona</Link></li>
            <li><Link to="/community" className="hover:text-yellow-400">Community</Link></li>
            <li><Link to="/lavora-con-noi" className="hover:text-yellow-400">Lavora con noi</Link></li>
            <li><Link to="/contatti" className="hover:text-yellow-400">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-widest">
            Legale
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-yellow-400">Privacy Policy</Link></li>
            <li><Link to="/cookie" className="hover:text-yellow-400">Cookie Policy</Link></li>
            <li><Link to="/termini" className="hover:text-yellow-400">Termini e condizioni</Link></li>
            <li><Link to="/gioco-responsabile" className="hover:text-yellow-400">Gioco responsabile</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-widest">
            Contatti
          </h4>
          <div className="flex flex-wrap gap-3">
            <a href={s.instagram_url} target="_blank" rel="noopener"
              onClick={() => trackClick("instagram")}
              data-testid="footer-instagram"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-yellow-400 hover:text-yellow-400 transition-colors duration-200">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={s.telegram_bot_url} target="_blank" rel="noopener"
              onClick={() => trackClick("telegram_bot")}
              data-testid="footer-telegram-bot"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-yellow-400 hover:text-yellow-400 transition-colors duration-200">
              <Send className="w-5 h-5" />
            </a>
            <a href={s.whatsapp_url} target="_blank" rel="noopener"
              onClick={() => trackClick("whatsapp")}
              data-testid="footer-whatsapp"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-yellow-400 hover:text-yellow-400 transition-colors duration-200">
              <MessageCircle className="w-5 h-5" />
            </a>
            <a href={`mailto:${s.vinko_email}`}
              data-testid="footer-email"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-yellow-400 hover:text-yellow-400 transition-colors duration-200">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8 text-xs text-zinc-500 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <p className="mb-2">
              Vinko non è un bookmaker e non gestisce conti di gioco, depositi,
              prelievi o scommesse. Tutte le registrazioni vengono effettuate sui
              siti ufficiali dei rispettivi operatori.
            </p>
            <p>
              Il gioco è vietato ai minori di 18 anni e può causare dipendenza
              patologica. Gioca responsabilmente.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center rounded-full border-2 border-yellow-400 text-yellow-400 font-black text-sm px-3 py-1">
              18+
            </span>
            <span className="text-zinc-600">© {new Date().getFullYear()} VINKO</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
